const useCountryByLang = (langCode: string): string => {
  const countryLangs: Record<string, string> = {
    en: 'gb',
  };
  return countryLangs[langCode] ?? langCode;
};

export default useCountryByLang;
